import { Controller } from "@hotwired/stimulus"

// MC-1008: swaps the inbound-rule action-settings fieldset in place when the
// action select changes. On change it points the settings Turbo Frame at the
// `action_fields` endpoint for the newly chosen action; Turbo fetches and
// replaces just that frame, so the top half of the form (topic, filter,
// action) is left untouched while the bottom half becomes the new action's
// settings. Progressive: with no JS the select still submits and the server
// renders the matching fieldset on the next request.
export default class extends Controller {
  static values = { url: String, frame: String }

  reload() {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("action_name", this.element.value)
    frame.setAttribute("src", url.pathname + url.search)
  }
}
